<script>
	import { Button } from '@infinitro/button';
	import { cfgToThemeCdnPath } from '@infinitro/config';
	import { t, Verbiage } from '@infinitro/content';
	import { isMobile, ModalDialog, pushModal } from '@infinitro/global';
	import { Text } from '@infinitro/text';

	const handleSignup = () => {
		pushModal(ModalDialog.Auth, { tab: 'signup' });
	};
</script>

<div class="hero-container">
	<img
		src={cfgToThemeCdnPath(`/about-vip/vip-background.png`)}
		alt={$t(Verbiage.about_vip_alternative2_alt)}
		class="background-image"
	/>
	<div class="hero-button-container">
		{#key $isMobile}
			<Text
				type="title"
				titleSize="h4"
				titleWeight="semibold"
				textAlign="center"
				customStyle="text-transform: uppercase; max-width: 250px;"
				>{$t(Verbiage.begin_your_journey)}</Text
			>
		{/key}
		<Button
			text={`${$t(Verbiage.sign_up)}`}
			id="signUp"
			variant="primary"
			onClick={handleSignup}
			whiteSpace="nowrap"
			minWidth
			styleCustom="border-radius: 4px; height: 48px;"
		/>
	</div>
</div>

<style>
	.hero-container {
		position: relative;
		height: 100%;
		width: 100%;
}

	.background-image {
		height: auto;
		width: 140%;
		max-width: none;
		--tw-translate-x: -14%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-o-object-fit: cover;
		   object-fit: cover;
}

	.btn-star-deco {
		position: absolute;
		right: 15px;
		top: calc(50% - 60px);
		width: 80px;
		height: 80px;
		pointer-events: none;
		background-repeat: no-repeat;
		background-size: contain;
		opacity: 0.5;
		mix-blend-mode: plus-lighter;
		clip-path: inset(0 0 0 0);
	}

	.btn-star-deco-2 {
		top: auto;
		bottom: -40px;
		right: auto;
		left: 30px;
		width: 80px;
		height: 80px;
		opacity: 0.5;
	}

	.hero-button-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
}

	@media (min-width: 1024px) {
		.background-image {
				width: 100%;
				max-width: 100%;
				--tw-translate-x: -0px;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		}

		.hero-button-container {
				position: absolute;
				bottom: 15%;
				left: 50%;
				display: flex;
				--tw-translate-x: -50%;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
				flex-direction: column;
				align-items: center;
				gap: 1rem;
		}
	}
</style>
